// "use client";
// import dynamic from "next/dynamic";
// import PropTypes from "prop-types";

// const BlogSlider = dynamic(() => import("./blog-slider"), {
//   ssr: false,
//   loading: () => null, // or your loader component
// });

// export default function BlogSection({initialBlogs=[]}) {
//   return <BlogSlider initialBlogs={initialBlogs}/>;
// }

// BlogSection.propTypes = {
//   className: PropTypes.string,
// };

import dynamic from "next/dynamic";
import PropTypes from "prop-types";

const BlogSlider = dynamic(() => import("./blog-slider"), {
  loading: () => <div className="min-h-[420px] w-full" />, // match real height
});

export default function BlogSection({ initialBlogs = [] }) {
  return <BlogSlider initialBlogs={initialBlogs} />;
}

BlogSection.propTypes = {
  className: PropTypes.string,
};
